import React from "react";
import Menu from "./menu/Menu";
import Footer from "./footer/Footer";

function Template(props) {
    return (
        <div>
            <Menu/>
            <div style={{paddingBottom: '50px'}}>
                {props.children}
            </div>
            <Footer/>
        </div>
    );
}

export default Template;
